<div class="onboarding-form onboarding-form-wider-2">
  <h1>Upload your declaration certificate</h1>
  <p class="text-muted fw-semibold">
    Please upload your business’ <span class="fw-bold">latest</span> declaration certificate, available from CIPC.
  </p>

  <p class="text-muted fw-semibold">
    If any details does not match up with the records currently with CIPC (including director information, business
    address, etc.), the certificate will be rejected.
  </p>

  @if (!documentUrl) {
    <app-upload
      #uploadRef
      class="demo-container"
      [settings]="uploadSettings"
      textExtra="Please ensure your file is the latest version available and is in PDF format"
      (uploadSuccess)="documentUploaded($event)"></app-upload>
  } @else {
    <app-file-upload
      [file]="file"
      (changeFile)="onChangeDocument($event)"></app-file-upload>
  }

  <app-pays-checkbox
    [(control)]="chkBoxValue"
    [label]="'I understand that once the business certificate is uploaded, the directors listed on the certificate will be notified to authorise registration.'"
    [id]="'cert_checkbox'"></app-pays-checkbox>

  <div class="mt-5">
    <button
      class="btn btn-primary btn-lg"
      id="signupBizCertSubmitBtn"
      [disabled]="disabledBtn()"
      (click)="onSubmit()">
      Continue
      <i class="ms-2 iconoir-arrow-right"></i>
    </button>
  </div>
</div>

<app-profile-dropdown [signUpFlow]="true"></app-profile-dropdown>
